export default __webpack_public_path__ + "images/2c1ea24cef3397c2b6945e7d665b3a5a-diy_small.webp";